import { trackAdClick as snowplowTrackAdClick } from '@snowplow/browser-plugin-ad-tracking';
import type { SelfDescribingJson } from '@snowplow/browser-tracker';

interface TrackAdClickData {
  targetUrl: string;
  clickId?: string;
  costModel?: 'cpa' | 'cpc' | 'cpm';
  cost?: number;
  bannerId?: string;
  impressionOrder: string;
  advertiserId: string;
  campaignId?: string;
  impressionId?: string;
}

/**
 * Track trackAdClick event in Snowplow.
 * v.0.13.0;
 * @public
 *
 * @param trackAdClickData - Object that contains event properties described in the Ad click tracking document
 * (see https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/browser-tracker/browser-tracker-v3-reference/tracking-events/#trackadclick ).
 *
 * @example
 * ```ts
 *
 * import {trackAdClick} from '@hc-frontend/third-party-snowplow';
 *
 * trackAdClick({
 * targetUrl: 'http://www.example.com',
 * clickId: '12243253',
 * costModel: 'cpm',
 * cost: 2.5,
 * bannerId: '23',
 * impressionOrder: '7',
 * advertiserId: '201',
 * campaignId: '12',
 * impressionId: 'c8514213-d397-4956-bc4c-fd2561090e85',
 * });
 * ```
 */
function trackAdClick(
  trackAdClickData: TrackAdClickData,
  contexts?: Array<SelfDescribingJson> | null,
): void {
  const {
    targetUrl,
    clickId,
    costModel,
    cost,
    bannerId,
    impressionOrder,
    advertiserId,
    campaignId,
    impressionId,
  } = trackAdClickData;
  snowplowTrackAdClick({
    targetUrl,
    clickId,
    costModel,
    cost,
    bannerId,
    zoneId: impressionOrder,
    advertiserId,
    campaignId,
    impressionId,
    context: contexts,
  });
}

export { trackAdClick };
export type { TrackAdClickData };
